import Highcharts from 'highcharts';

// Types
import { HighchartPoint } from '@/views/components/charts/utils/types/tooltip';

// Utils
import { formatMessage, formatNumber, formatPercentage } from '@/utils/i18n';

export const getIconName = (symbol: string) => {
  switch (symbol) {
    case 'diamond':
      return 'icon-icon-diamond';
    case 'circle':
      return 'icon-icon-circle';
    default:
      return '';
  }
};

export function getScatterPlotTooltipHeader(point: HighchartPoint) {
  if (!point) return '';
  return `<div class="chart-tooltip-header">
    <i class="${getIconName(point.marker?.symbol ?? '')} holding-icon" style="color: ${point.color};"></i>
    <span class="chart-tooltip-header-name m-0" data-private data-dd-privacy="mask" style="font-size: 14px;">${point.name ?? ''}</span>
  </div>`;
}

export function getScatterPlotTooltipBody(point: HighchartPoint) {
  if (!point) return '';
  return `<div class="chart-tooltip-body">
    <p class="chart-tooltip-body-text m-0" data-private data-dd-privacy="mask">
      <strong>${point.nameSuffix ?? ''}</strong>
    </p>
    <p class="chart-tooltip-body-text m-0" data-private data-dd-privacy="mask">
      <strong>${formatMessage('RiskRewardPlot.Tooltip.LabelX')}</strong>
      ${point.x && formatNumber(point.x, 2)}
    </p>
    <p class="chart-tooltip-body-text m-0" data-private data-dd-privacy="mask">
      <strong>${formatMessage('RiskRewardPlot.Tooltip.LabelY')}</strong>
      ${point.y && formatPercentage(point.y, 2)} ${point.currency ?? ''}
    </p>
  </div>`;
}

export function scatterPlotTooltipFormatter(this: Highcharts.TooltipFormatterContextObject & { point: HighchartPoint }) {
  const header = getScatterPlotTooltipHeader(this.point);
  return header + getScatterPlotTooltipBody(this.point);
}
